import styled from "styled-components";


export const OrganizationCardContainer = styled.section`
  display: flex;
  align-items: center;
  background: white;
  padding: 1.5rem;
  margin: 1.5rem;
  border-radius: 8px;
`;

export const OrganizationLogo = styled.img`
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 50%;
`;

export const OrganizationInfo = styled.div`
  margin-left: 1rem;
  flex: 1;
`;

export const OrganizationName = styled.h3`
  margin: 0 0 0.25rem;
`;

export const OrganizationDescription = styled.p`
  margin: 0 0 0.5rem;
  font-size: 0.95rem;
  color: #444;
`;

export const LearnMoreLink = styled.a`
  color: #fe2f67;
  text-decoration: none;
  margin-left: auto;
  display: block;
  width: fit-content;
  &:hover {
    text-decoration: underline;
  }
`;